<app-base-modal
  [title]="'Добавить телеграм аккаунт'"
>
  <div>
    <mat-stepper
      #stepper
      [linear]="isLinear"
      [orientation]="isMobile ? 'vertical' : 'horizontal'"
    >
      <mat-step
        label="Добавление"
        [stepControl]="formGroup"
      >
        <app-add-telegram-account-form
          [formGroup]="formGroup"
          [currentStep]="stepper.selectedIndex"
          [formFields]="addTelegramAccountFormFields"
        />
      </mat-step>
      <mat-step label="Код подтверждения">
        <app-add-telegram-account-form
          [formGroup]="codeFormGroup"
          [currentStep]="stepper.selectedIndex"
          [formFields]="addTelegramAccountCodeFormFields"
        />
      </mat-step>
      <mat-step label="Готово">
        <app-add-telegram-account-form
          [formGroup]="formGroup"
          [currentStep]="stepper.selectedIndex"
          [formFields]="addTelegramAccountFormFields"
        />
      </mat-step>
    </mat-stepper>
    <div class="buttons-container">
      <button
        mat-button
        color="warn"
        type="button"
        (click)="closeDialog('cancel')"
      >
        {{ (stepper.selectedIndex !== 2 ? 'Отмена' : 'Закрыть') }}
      </button>
      @if (stepper.selectedIndex !== 2) {
        <button
          mat-button
          color="primary"
          type="button"
          [disabled]='isDisabledBtn(stepper.selectedIndex)'
          (click)="handleBtnClick(stepper.selectedIndex)"
        >
          Получить код
        </button>
      }
    </div>
  </div>
</app-base-modal>
